export class AppConstants {
  public static readonly PARENT_TEMPLATE_ID = 'parentTemplateId';
  public static readonly CURRENT_APP_TYPE = 'currentApplicationType';
  public static readonly ITEMS_TO_CUT = 'ITEMSTOCUT';
  public static readonly MODULES_CLIPBOARD = 'MODULES_CLIPBOARD';
  public static readonly LAST_SYNC_DATE = 'LastSyncDate';
  public static readonly CURRENT_LANGUAGE = 'currentLanguage';
  public static readonly OFFLINE_INSPECTION = 'offlineInspection';
  public static readonly OFFLINE_INSPECTION_NAME = 'offlineInspectionName';
  public static readonly OFFLINE_INSPECTION_APP_TYPE = 'offlineInspectionApplicationType';
  public static readonly CURRENT_USER = 'currentUser';
  public static readonly CURRENT_USER_NAME = 'currentUserName';
  public static readonly APP_REF_LAST_SYNC_DATE = 'AppRefLastSyncDate';
  public static readonly INDEXEDDB_MAINTENANCE_DB = 'maintenance_database';
  public static readonly INDEXEDDB_OPTIMIZATION_DB = 'optimization_database';
  public static readonly INDEXEDDB_INSTALLATION_DB = 'installation_database';
  public static readonly LAST_OPENED_PLUGIN_ID = 'last_opened_plugin_id';
  public static readonly SESSION_ID = 'session_id';
  public static readonly INDEXEDDB_TABLES = {
    inspections: 'inspections',
    permissions: 'permissions',
    people: 'people',
    templates: 'templates',
    translations: 'translations',
    productLines: 'productLines',
    models: 'models',
    categories: 'categories',
    images: 'images',
    languages: 'languages',
    applicationTypes: 'applicationTypes',
    actionPlans: 'actionPlans',
    localEntities: 'localEntities',
    countries: 'countries',
    trainees: 'trainees',
    moments: 'moments',
    courses: 'courses',
    currencies: 'currencies',
    pluginModels: 'pluginModels'
  };
  public static readonly DASHBOARD_STATISTIC = 'dashboard_statistic';

  public static readonly PLUGINS_URL = {
    associateequipment: (plugin) => `/inspections/${plugin.inspectionId}/plugins/associate/${plugin.id}`,
    attachements: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/attachements/${plugin.id}/config`,
    bardepinceslockingcheck: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/barredepinceslockingcheck/${plugin.id}`,
    spolocking: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/spolocking/${plugin.id}`,
    boxes: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/boxes/${plugin.id}`,
    comment: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/comment/${plugin.id}`,
    contact: (plugin) => `/inspections/${plugin.inspectionId}/plugins/contact/${plugin.id}`,
    counter: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/counter/${plugin.id}`,
    counterpressurecylinder: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/counterpressurecylinder/${plugin.id}`,
    customerremark: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/customerremark/${plugin.id}`,
    customerselector: (plugin) => `/inspections/${plugin.inspectionId}/plugins/${plugin.id}/customer`,
    cycles: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/cycles/${plugin.id}`,
    cylindricalparallelism: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/cylindricalParallelism/${plugin.id}`,
    executivesummary: (plugin) => `/inspections/${plugin.inspectionId}/plugins/executivesummary/${plugin.id}`,
    files: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/files/${plugin.id}/config`,
    filemanager: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/filemanager/${plugin.id}/config`,
    filesandsuggestions: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/filesandsuggestions/${plugin.id}/config`,
    inspectionInfo: (plugin) => `/inspections/${plugin.inspectionId}/plugins/inspectioninfo/${plugin.id}`,
    jobanalysis: (plugin) => `/inspections/${plugin.inspectionId}/plugins/jobanalysis/${plugin.id}`,
    machineselector: (plugin) => `/inspections/${plugin.inspectionId}/plugins/${plugin.id}/machine/postmachine`,
    observationsandrecommandations: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/observations/${plugin.id}`,
    optimisationmachineselector: (plugin) =>
      `/inspections/${plugin.inspectionId}/plugins/machine/${plugin.id}/optimisation`,
    pointparts: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/parts/${plugin.id}`,
    parts: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/parts/${plugin.id}`,
    peripheralinfo: (plugin) => `/inspections/${plugin.inspectionId}/plugins/peripheralinfo/${plugin.id}`,
    recommendedparts: (plugin) => `/inspections/${plugin.inspectionId}/plugins/recommendedparts/${plugin.id}`,
    repairdays: (plugin) => `/inspections/${plugin.inspectionId}/plugins/repairdays/${plugin.id}`,
    responsedate: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/responsedate/${plugin.id}`,
    responsenumber: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/responsenumber/${plugin.id}`,
    responseboolean: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/responseboolean/${plugin.id}`,
    softwareinfo: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/softwareinfo/${plugin.id}`,
    states: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/states/${plugin.id}`,
    timecounter: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/timecounter/${plugin.id}`,
    timesheet: (plugin) => `/inspections/${plugin.inspectionId}/plugins/timesheet/${plugin.id}`,
    timetorepair: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/timetorepair/${plugin.id}`,
    totaltimetorepair: (plugin) => `/inspections/${plugin.inspectionId}/plugins/totaltimetorepair/${plugin.id}`,
    trainingproposals: (plugin) => `/inspections/${plugin.inspectionId}/plugins/trainingproposals/${plugin.id}`,
    participants: (plugin) => `/inspections/${plugin.inspectionId}/plugins/participants/${plugin.id}`,
    marketing: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/marketing/${plugin.id}`,
    upgrades: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/upgrades/${plugin.id}`,
    obsolescences: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/obsolescences/${plugin.id}`,
    spotrain: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/spotrain/${plugin.id}`,
    machinesafety: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/machinesafety/${plugin.id}`,
    score: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/score/${plugin.id}`,
    actions: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/actions/${plugin.id}`,
    actionscompleted: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/actionscompleted/${plugin.id}`,
    reportadviseremarks: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/reportadviseremarks/${plugin.id}`,
    assistance: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/assistance/${plugin.id}`,
    effects: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/effects/${plugin.id}`,
    inherentrisk: (plugin) => `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/inherentrisk/${plugin.id}`,
    installationcustomercontact: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/customercontact/${plugin.id}`,
    installationvoltage: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/voltage/${plugin.id}`,
    installationfreetext: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/freetext/${plugin.id}`,
    installationreceived: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/received/${plugin.id}`,
    installationchecked: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/checked/${plugin.id}`,
    installationweight: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/weight/${plugin.id}`,
    installationincoterms: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/incoterms/${plugin.id}`,
    installationcustomerinfo: (plugin) =>
      `/inspections/${plugin.inspectionId}/plugins/${plugin.id}/installationcustomerinfo`,
    installationdate: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/date/${plugin.id}`,
    installationdimensions: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/dimension/${plugin.id}`,
    installationroadsurface: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/roadsurface/${plugin.id}`,
    installationgroundlevel: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/groundlevel/${plugin.id}`,
    installationinspectioninfo: (plugin) =>
      `/inspections/${plugin.inspectionId}/plugins/installationinspectioninfo/${plugin.id}`,
    installationequipmentinfo: (plugin) =>
      `/inspections/${plugin.inspectionId}/installation/equipmentinfo/${plugin.id}`,
    installationstaff: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/staff/${plugin.id}`,
    installationduration: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/duration/${plugin.id}`,
    installationstatus: (plugin) =>
      plugin.pointId
        ? `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/status/${plugin.id}`
        : `/inspections/${plugin.inspectionId}/plugins/installation/status/${plugin.id}`,
    installationpreparationneeded: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/preparation/${plugin.id}`,
    installationdistance: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/distance/${plugin.id}`,
    installationanilox: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/anilox/${plugin.id}`,
    installationparty: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/party/${plugin.id}`,
    installationcustomercomments: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/customercomments/${plugin.id}`,
    installationcomments: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/comments/${plugin.id}`,
    installationbobstcontact: (plugin) =>
      `/inspections/${plugin.inspectionId}/plugins/installation/bobstcontact/${plugin.id}`,
    installationcustomerattendees: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/customerattendees/${plugin.id}`,
    installationbobstattendees: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/bobstattendees/${plugin.id}`,
    installationlubricant: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/lubricant/${plugin.id}`,
    installationpartybccbsa: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/partybccbsa/${plugin.id}`,
    installationyesno: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/yesno/${plugin.id}`,
    installationjobproduced: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/jobproduced/${plugin.id}`,
    installationtrainingprovided: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/trainingprovided/${plugin.id}`,
    installationexecutivesummary: (plugin) =>
      `/inspections/${plugin.inspectionId}/plugins/installation/executivesummary/${plugin.id}`,
    installationsignature: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/signature/${plugin.id}`,
    installationformfile: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/formfile/${plugin.id}`,
    installationobservation: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/installation/observation/${plugin.id}`,
    interventiontasks: (plugin) =>
      `/inspections/${plugin.inspectionId}/points/${plugin.pointId}/interventiontasks/${plugin.id}`
  };
}
